import axios from 'axios';
import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import SuggestionAPI, { SuggestionItemType } from '../../../api/suggestion.api';
import { bugsnagNotify } from '../../../bugsnag';
import { useRootStoreContext } from '../../../stores/RootStore';
import { SuggestionItem } from '../../SuggestionItem';
import moment from 'moment-timezone';

const AllSuggestionsStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 8px;

    > button {
        min-width: 56px;
        margin-right: 8px;
        margin-bottom: 8px;
    }
`;

type Props = {
    restaurantId: number;
    restaurantSlug: string;
};

const suggestionApi = new SuggestionAPI();

const AllSuggestions: FC<Props> = ({ restaurantId, restaurantSlug }) => {
    const {
        SearchCriteriaStore: {
            reducer: [{ dateTime, guests }],
        },
    } = useRootStoreContext();
    const [allSuggestions, setAllSuggestions] = useState<
        SuggestionItemType[] | null
    >(null);

    useEffect(() => {
        const cancelToken = axios.CancelToken.source();

        suggestionApi
            .getAllSuggestionsByRestaurantId(
                restaurantId,
                moment(dateTime, moment.defaultFormatUtc).format(
                    'YYYY-MM-DDTHH:mm',
                ),
                guests,
                cancelToken,
            )
            .then((res) => {
                setAllSuggestions(
                    res.data.map((x) => ({
                        ...x,
                        date: moment(x.date, moment.defaultFormatUtc),
                    })),
                );
            })
            .catch((e) => {
                if (!axios.isCancel(e)) {
                    bugsnagNotify(e);
                }
            });

        return () => {
            cancelToken.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AllSuggestionsStyled>
            {allSuggestions === null ? (
                <>
                    <SuggestionItem isLoading />
                    <SuggestionItem isLoading />
                    <SuggestionItem isLoading />
                </>
            ) : (
                allSuggestions.map((x) => (
                    <SuggestionItem
                        key={`rest-modal-si-${x.date?.format(
                            "yyyy-MM-dd'T'HH:mm",
                        )}`}
                        data={x}
                        restaurantId={restaurantId}
                        restaurantSlug={restaurantSlug}
                        guests={guests}
                        showUnavailableTimes
                    />
                ))
            )}
        </AllSuggestionsStyled>
    );
};

export default AllSuggestions;
